import styled from 'styled-components';
import * as colors from '../../../common/colorConstants';
import { lowHeightScreens, mediumScreens, smallScreens } from '../../../common/fontElements';

const MacroText = styled.div`
  white-space: pre-wrap;
  ${(props) =>
    props.disableManualCopy &&
    `-webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    -o-user-select: none;
    user-select: none;`}

  img {
    width: auto;
    max-width: 800px;
  }
`;

const MacroHeader = styled.div`
  margin-bottom: 20px;
  padding: 20px 0px 20px;
  border-bottom: 1px solid ${colors.lightWhite2};
`;

const MacroContent = styled.div`
  white-space: normal;
  position: relative;
  color: ${colors.baseText};
  font-family: 'Lato-Light', sans-serif;
  font-weight: 300;
  line-height: normal;
  margin: 0px;
  border-bottom: 1px solid ${colors.lightWhite2};
  padding: 20px 0px;
`;

const TitleText = styled.p`
  font-family: Lato;
  font-size: 14px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: 0px;
  text-align: center;
  color: ${colors.black1};
  margin: 0px;
  @media screen and (max-width: ${mediumScreens}) {
    font-size: 13px;
  }
  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    font-size: 12px;
  }
  white-space: pre-wrap;
`;

export { TitleText, MacroContent, MacroHeader, MacroText };
